import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { EMBARCACAO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    EMBARCACAO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    EMBARCACAO_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [EMBARCACAO_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [EMBARCACAO_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [EMBARCACAO_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [EMBARCACAO_ENDPOINT],
    id
  );
}
